import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { HomeService } from '../services/home.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatIconModule } from '@angular/material/icon';

const ALLOWED_URLS = ['/inicio', '/empleo', '/formacion', '/que-hay-pa-hacer', '/servicios'];

@Component({
  selector: 'app-banner-popup',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './banner-popup.component.html',
  styleUrl: './banner-popup.component.scss'
})
export class BannerPopupComponent {

  url_s3 = environment.URL_S3;
  statusPopup = false;
  dataPopup: any;
  private popupData: any;
  private yaConsultado = false;
  private cerradoManualmente = false;

  constructor(private router :Router, private homeService: HomeService){}

  ngOnInit(): void {
    this.evaluarRuta(this.router.url);

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event) => {
      this.evaluarRuta((event as NavigationEnd).urlAfterRedirects);
    });
  }

  private esUrlPermitida(url: string): boolean {
    const path = url.split('?')[0].split('#')[0];
    return ALLOWED_URLS.some(allowed => path === allowed || path.startsWith(allowed + '/'));
  }

  private evaluarRuta(url: string): void {
    if (!this.esUrlPermitida(url)) {
      this.statusPopup = false;
      return;
    }

    if (this.cerradoManualmente) {
      return;
    }

    if (!this.yaConsultado) {
      this.yaConsultado = true;
      this.getBannerPopup();
    } else if (this.popupData) {
      this.dataPopup = this.popupData;
      this.statusPopup = true;
    }
  }

    getBannerPopup(){
    this.homeService.getBannerPopup().subscribe((response: any) => {


      if (response.rowCount != 0) {

        const randomIndex = Math.floor(Math.random() * response.data.length);
        this.popupData = response.data[randomIndex];
        this.dataPopup = this.popupData;
        this.statusPopup= true;

      } else {
        this.statusPopup= false;
        this.dataPopup = null;
      }
      // this.dataSliderHome = response.data
      // this.datosCargados.set(true); // Activas la señal
    });
  }


  cerrar() {
    this.statusPopup= false;
    this.dataPopup = null;
    this.cerradoManualmente = true;
  }


}
